import PaymentsService from "@/services/payments";
import serviceHandler from "@/helpers/handlers/service";

export default {
  async getPlans({ commit }) {
    const data = await serviceHandler(PaymentsService.getPlans());

    commit("SET_PLANS", data.plans);
    commit("SET_LIMITS_USAGE", data.limits_usage);

    const [plan] = data.plans;
    const [price] = plan.prices;
    const currency = price.currency;
    commit("SET_CURRENCY", currency.toUpperCase());
  },

  async getPricePreview({ commit, state, getters }) {
    if (!Object.keys(state.selectedPlan).length) {
      commit("SET_PRICE_PREVIEW", 0);
      commit("SET_TAX_PRICE", 0);

      return;
    }
    const data = await serviceHandler(
      PaymentsService.getPricePreview({
        currency: state.currency,
        items: [
          {
            price: state.selectedPlan.prices.find(item => {
              return item.recurring.interval === state.selectedPeriod;
            }).price_id,
            quantity: state.selectedLocationsCount
          }
        ],
        ...(state.promoCode && { promotion_code: state.promoCode })
      })
    );
    commit("SET_PRICE_PREVIEW", data.amount_due);
    commit("SET_TAX_PRICE", data.tax);
  },
  async setSelectedPlan({ commit }, payload) {
    commit("SET_SELECTED_PLAN", payload);
  },
  async setSelectedLocationsCount({ commit }, payload) {
    commit("SET_SELECTED_LOCATIONS_COUNT", payload);
  },
  async setSelectedPeriod({ commit }, payload) {
    commit("SET_SELECTED_PERIOD", payload);
  },
  async setSelectedPaymentMethod({ commit }, payload) {
    commit("SET_SELECTED_PAYMENT_METHOD", payload);
  },
  async getInitialChosenPlan({ commit }) {
    const { data: plan } = await PaymentsService.getInitialChosenPlan();
    commit("SET_INITIAL_CHOSEN_PLAN", plan || null);
  },
  async getPromotionCodes({ commit }) {
    const data = await serviceHandler(PaymentsService.getPromotionCodes());
    commit("SET_PROMOTION_CODES", data.length ? data : null);
  },
  setPromoCode({ commit }, payload) {
    commit("SET_PROMO_CODE", payload);
  },
  setPlanChangeType({ commit }, payload) {
    commit("SET_PLAN_CHANGE_TYPE", payload);
  },
  setInitialPlanIndex({ commit }, payload) {
    commit("SET_INITIAL_PLAN_INDEX", payload);
  }
};
